export const FETCH_PRODUCT = 'line-up/product/FETCH_PRODUCT';
export const FETCH_PRODUCTS = 'line-up/product/FETCH_PRODUCTS';
export const CREATE_PRODUCT = 'line-up/product/CREATE_PRODUCT';
export const UPDATE_PRODUCT = 'line-up/product/UPDATE_PRODUCT';
